'use client';

import { ComponentProps, FC } from 'react';

import { Image } from '@repo/ui/Image';
import { SearchAlertToggle } from '@/plp/components/SearchAlertToggle/SearchAlertToggle';

type LowResultsVariants = 'low-results' | 'no-results';

const SEARCH_ALERT_TOGGLE_CONTENT: Record<
  LowResultsVariants,
  {
    title: string;
    body: string;
  }
> = {
  'low-results': {
    title: 'Not quite what you’re looking for?',
    body: 'Set up an alert for your chosen filters and we will send an email when new inventory arrives.',
  },
  'no-results': {
    title: "We don't have any matches...yet",
    body: 'Set up an alert for your chosen filters and we will send an email when new inventory arrives',
  },
};

type SearchAlertTileProps = ComponentProps<typeof SearchAlertToggle> & {
  inactiveVariant: keyof typeof SEARCH_ALERT_TOGGLE_CONTENT;
};

export const SearchAlertTile: FC<SearchAlertTileProps> = (props) => (
  <section
    className="box-shadow-elevation-0dp flex flex-col gap-6 rounded-md border border-bor-neu-mut bg-bac-tie1 p-6 transition-colors duration-200 sm:flex-row sm:justify-between"
    data-testid="SearchAlertTile-container"
  >
    <div className="flex flex-col gap-6 sm:flex-row sm:items-start">
      <Image
        src="/images/components/BadgeIllustration/quality.svg"
        alt=""
        width={80}
        height={80}
        className="block size-20 sm:size-16"
      />
      <div>
        {props.isActive ? (
          <>
            <h5 className="c-fs-h5 mb-1 font-extrabold md:mb-2">Search alert set!</h5>
            <p className="c-fs-body-1">Check your inbox for new arrivals that match this filter selection</p>
          </>
        ) : (
          <>
            <h5 className="c-fs-h5 sm:md-2 mb-1 font-extrabold">
              {SEARCH_ALERT_TOGGLE_CONTENT[props.inactiveVariant].title}
            </h5>
            <p className="c-fs-body-1">{SEARCH_ALERT_TOGGLE_CONTENT[props.inactiveVariant].body}</p>
          </>
        )}
      </div>
    </div>
    <div data-testid="search-alert-control-tile">
      <SearchAlertToggle {...props} />
    </div>
  </section>
);
